import { useDateCountdown } from '@/scopes/prices/domain/promoted-price/hooks'
import { Icon, type IconGlyph, tk, tok } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

interface CampaignDurationBannerProps {
  icon?: IconGlyph
  text?: string
  endDate?: string
}

const Wrapper = styled.div`
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between !important;
    margin: ${tk('spacing_xs')} 0 ${tk('spacing_lg')} 0;
    padding: ${tk('spacing_sm')}  ${tk('spacing_md')};
    border-radius: ${tk('radius_large')};
    background: #FCEDEB;
    width: 100%;
    height: 48px;
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;

  ${Typography} {
    color: ${tok('primitives_color_primary_550')};
    margin-right: ${tk('spacing_xs')}
  }
`

const BannerIcon = styled(Icon)`
  color: ${tok('primitives_color_primary_550')};
  margin-right: ${tk('spacing_xs')};
`

const CountDown = styled(Typography)`
  color: ${tok('semantics_content_color')};
`

export function CampaignDurationBanner({ text, icon, endDate }: CampaignDurationBannerProps) {
  const { timeToEnd, counterEnded } = useDateCountdown(endDate || '')
  if (!icon || !text || !endDate || counterEnded || !timeToEnd) {
    return null
  }

  return (
    <Wrapper>
      <ContentWrapper>
        <BannerIcon size="md" glyph={icon} />
        <Typography $variant="body-m-bold-tight">{text}</Typography>
      </ContentWrapper>
      <CountDown $variant="body-m-regular-tight">{ timeToEnd }</CountDown>
    </Wrapper>
  )
}
